import type { PreloadedQuery } from 'react-relay';
import { createRelayResource } from '@atlassian/jira-relay-utils/src/services/resources/index.tsx';
import MAIN_CODE_PAGE_QUERY, {
	type CodePageRootQuery as MainCodeInJiraUpdatedQuery,
} from '@atlassian/jira-relay/src/__generated__/CodePageRootQuery.graphql';
// eslint-disable-next-line jira/import-whitelist
import {
	getPullRequestsUpdatedFromDate,
	getNumPullRequestsToFetch,
} from '@atlassian/jira-software-code-page/src/common/utils.tsx';
import type {
	RouterDataContext,
	ResourceStoreContext,
	RouterContext,
	RouteResource,
} from '@atlassian/react-resource-router';
import { RESOURCE_TYPE_CODE } from '../constants.tsx';

let numPullRequestsToFetch = 0;

// @deprecated - use codePageV2Resource instead (this is the old code page resource)
// TODO: remove this once we cleanup `jira-code-page-to-ugs-v2`
export const codePageResource: RouteResource<
	PreloadedQuery<MainCodeInJiraUpdatedQuery, Record<string, unknown>>
> = createRelayResource<MainCodeInJiraUpdatedQuery>({
	type: RESOURCE_TYPE_CODE,
	getQuery(
		{ match: { params }, query, route: { name } }: RouterDataContext | RouterContext,
		{ tenantContext: { cloudId } }: ResourceStoreContext,
	) {
		const isCodeRoute = name === 'software-code' || name === 'software-code-classic';
		// Set numPullRequestsToFetch on initial call only and not on every query param change
		if (!numPullRequestsToFetch && isCodeRoute) {
			numPullRequestsToFetch = getNumPullRequestsToFetch(query);
		}
		// Reset numPullRequestsToFetch when navigating away from the code page
		if (!isCodeRoute) {
			numPullRequestsToFetch = 0;
		}

		return {
			parameters: MAIN_CODE_PAGE_QUERY,
			options: {
				fetchPolicy: 'store-and-network',
			},
			variables: {
				cloudId,
				projectKey: params.projectKey ?? '',
				pullRequestsUpdatedFrom: getPullRequestsUpdatedFromDate(),
				numPullRequestsToFetch,
				siteAri: `ari:cloud:jira::site/${cloudId}`,
			},
		};
	},
});
